// Single source of truth for the backend base URL.
//
// Convention: REACT_APP_BACKEND_URL is the backend ORIGIN, WITHOUT a trailing
// "/api" (e.g. https://staging.vat.support, or empty for a same-origin dev
// proxy). Every backend route lives under /api, so we append it here exactly
// once. A trailing slash or an accidental trailing "/api" in the env value is
// tolerated and normalized away, so the value can never produce "/api/api"
// (the staging login/flags 404 bug).

// Pure + exported for testing: origin -> "<origin>/api" (single /api, no dupes).
export function apiBaseFrom(raw) {
  const origin = (raw || "").trim().replace(/\/+$/, "").replace(/\/api$/, "");
  return `${origin}/api`;
}

export const BACKEND_ORIGIN = (process.env.REACT_APP_BACKEND_URL || "")
  .trim()
  .replace(/\/+$/, "")
  .replace(/\/api$/, "");

// The /api base every axios client and download href must use.
export const API = apiBaseFrom(process.env.REACT_APP_BACKEND_URL);
